import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle, FiXCircle } from 'react-icons/fi';
import { useField, FormHandles } from '@unform/core';
import { Container, Field } from './styles';

import { urlWebsite } from '../../../../../../config';
import api from '../../../../../../services/api';
import {
  FaArrowUp,
  FaArrowDown,
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaArrowCircleUp,
  FaArrowCircleDown,
  FaFilePdf,
  FaFileExcel,
} from 'react-icons/fa';
import { MdRemoveCircle } from 'react-icons/md';
import { useToast } from '../../../../../../hooks/Toast';
import resizeImage from '../../../../../../utils/resizeImage';
import { uuid } from 'uuidv4';

interface IImage {
  name?: string;
  url?: string;
  title?: string;
  description?: string;
  link_url?: string;
}

interface IInputProps {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  setCallback?: Function;
  formRef?: React.RefObject<FormHandles>;
  list: Array<IImage>;
  placeholder: string;
}



const ImageMultiGalleryInputToStatic: React.FC<IInputProps> = ({
  name,
  icon: Icon,
  formRef,
  setCallback = () => { },
  list,
  ...rest
}) => {
  const { fieldName, defaultValue, error, registerField } = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);
  const inputRef2 = useRef<HTMLInputElement>(null);
  const [isFocus, setIsFocus] = useState(false);
  const [isFilled, setIsFilled] = useState(!!defaultValue);
  const { addToast } = useToast();
  const [loadingUpload, setLoadingUpload] = useState(false);

  const [valueImage, setValueImage] = useState<Array<IImage>>(
    defaultValue || [],
  );

  useEffect(() => {
    console.log(defaultValue);
  }, [])

  const handleInputBlur = useCallback(() => {
    setIsFocus(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  const handleInputFocus = useCallback(() => {
    setIsFocus(true);
  }, []);
  const uploadPhoto = async (ref, e) => {
    setLoadingUpload(true);
    const files = e.target.files;
    let x = 0;
    const length = files?.length;

    while (x < length) {
      const file = files?.[x];
      console.log(x, file);

      const isImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
      const isPDF = file.type === 'application/pdf';
      const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (!isImage && !isPDF && !isExcel) {
        addToast({ title: 'Somente são aceitos JPEG, PNG, PDF e Excel', type: 'error' });
        if (inputRef2?.current) {
          inputRef2.current.value = '';
        }
        setLoadingUpload(false);
        return;
      }

      const formData = new FormData();

      if (isImage) {
        const resizedImage = await resizeImage(file);
        const newFile = new File([resizedImage], `${uuid()}.jpeg`, { type: resizedImage.type });
        formData.append('file', newFile);
      } else {
        // Para PDF ou Excel, envia o arquivo original
        formData.append('file', file);
      }

      try {
        const response = await api.post('/uploadImageToStatic', formData);
        const data = [{ url: response?.data?.message }];
        setTimeout(() => {
          setValueImage(state => [...state, ...data]);
        }, 2000);

        if (inputRef2?.current) {
          // opcional: limpar input
        }
        setLoadingUpload(false);
      }
      catch (err) {
        setLoadingUpload(false);
        if (inputRef2?.current) {
          // opcional: limpar input
        }
        addToast({ title: err?.response?.data?.message || err?.response?.data?.error || 'Erro ao realizar upload', type: 'error' });
      }

      x = x + 1;
    }
  };


  const removeImage = index => {
    const data = [...valueImage];
    data.splice(index, 1);
    setValueImage([...data]);
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: undefined,

      getValue: (ref: any) => {
        return valueImage || [];
      },
      setValue: (ref: any, value) => {
        setValueImage(value || []);
      },
    });
  }, [fieldName, registerField, valueImage]);

  const removeFromSalesCourses = (index: number): void => {


    const SalesCoursesValues = valueImage.filter(
      (item, indexSalesCourses, array) => {
        return array.indexOf(item) !== index;
      },
    );


    setValueImage([...SalesCoursesValues]);
  };

  const goUp = index => {
    const indexup = index - 1;

    if (valueImage[indexup]) {
      const newCurrent = [...valueImage];

      newCurrent[index] = valueImage[indexup];
      newCurrent[indexup] = valueImage[index];

      setValueImage([...newCurrent]);

    }
  };

  const goDown = index => {
    const indexup = index + 1;

    if (valueImage[indexup]) {
      const newCurrent = [...valueImage];

      newCurrent[index] = valueImage[indexup];
      newCurrent[indexup] = valueImage[index];


      setValueImage([...newCurrent]);
    }
  };

  const goAllUp = index => {
    if (valueImage[index]) {
      const newCurrent = [...valueImage];
      const content = { ...newCurrent[index] };

      newCurrent.splice(index, 1);

      newCurrent.unshift(content);

      setValueImage([...newCurrent]);
    }
  };

  const goAllDown = index => {
    if (valueImage[index]) {
      const newCurrent = [...valueImage];

      const content = newCurrent[index];

      newCurrent.splice(index, 1);

      newCurrent.push(content);

      setValueImage([...newCurrent]);
    }
  };
  const printLine = (name, index, list) => {
    const inputs: Array<JSX.Element> = [];

    Object.keys(list).map((key) => {
      const fileUrl = `https://content.encontrodigital.com.br/${valueImage?.[index]?.[list?.[key]?.name]}`;
      const fileName = valueImage?.[index]?.[list?.[key]?.name] || '';

      const isImage = fileName.endsWith('.jpeg') || fileName.endsWith('.jpg') || fileName.endsWith('.png');
      const isPDF = fileName.endsWith('.pdf');
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

      if (list[key].name === 'image' || list[key].name === 'photo' || list[key].name === 'url') {
        if (isImage) {
          inputs.push(
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <img
                alt="Foto"
                src={fileUrl}
                style={{ width: '100px', objectFit: 'contain' }}
              />
            </a>
          );
        } else if (isPDF) {
          inputs.push(
            <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaFilePdf size={40} color="#E74C3C" />
              <span>PDF</span>
            </a>
          );
        } else if (isExcel) {
          inputs.push(
            <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaFileExcel size={40} color="#27AE60" />
              <span>Excel</span>
            </a>
          );
        } else {
          // Se não for imagem/pdf/excel, mostra apenas o link
          inputs.push(
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              Arquivo
            </a>
          );
        }
      } else {
        inputs.push(
          <Field key={`${name}_${index}_${key}`}>
            <span>{list[key].label}</span>
            <input
              placeholder={list[key].label}
              defaultValue={
                valueImage && valueImage[index] && valueImage[index][list[key].name]
                  ? valueImage[index][list[key].name]
                  : ''
              }
              onChange={e => {
                let newValue = [...valueImage];
                if (!newValue[index]) { newValue[index] = {}; }
                newValue[index][list[key].name] = e.target.value;
                setValueImage([...newValue]);
              }}
              name={`${name}_${index}_${list[key].name}`}
            />
          </Field>
        );
      }
    });

    return inputs;
  };


  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
    >
      <Container>
        <input
          ref={inputRef}
          style={{ display: 'none' }}
          name={name}
          value={JSON.stringify(valueImage)}
        />
        <span>{rest.placeholder}</span>
        {Icon && <Icon />}
        <input
          {...rest}
          multiple={true}
          type="file"
          onChange={e => {
            setCallback(e.target.value, formRef);
            uploadPhoto(inputRef2.current, e)
          }}
          ref={inputRef2}
        />


      </Container>
      {loadingUpload ? <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
        <p style={{ fontSize: '12px', padding: '10px', textAlign: 'center', width: '100%', background: 'orange', color: '#fff' }}>Upload em andamento...</p>
      </div> : <></>}
      <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
        {valueImage && valueImage?.length > 0 && valueImage?.map((line, index) => (
          <div style={{ width: '100%', margin: '5px', position: 'relative' }}>


            <Container>    {printLine(name, index, list)}
              <div
                style={{
                  width: '20px',
                  height: '20px',

                  cursor: 'pointer',
                }}
                onClick={() => removeImage(index)}
              >
                <FiXCircle />
              </div>
            </Container>



          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageMultiGalleryInputToStatic;
